import React from "react";
import AuthService from "../services/auth.service";
import { t, subscribeLanguage } from "../i18n";
import LanguageSwitcher from "../component/LanguageSwitcher";

export default class Header extends React.Component {
    private unsubscribeLang?: () => void;

    componentDidMount() {
        this.unsubscribeLang = subscribeLanguage(() => this.forceUpdate());
    }

    componentWillUnmount() {
        this.unsubscribeLang?.();
    }

    logout = () => {
        AuthService.logout();
        window.location.reload();
        console.log("header logout");
    };

    render() {
        return (
            <header className="topbar">
                <nav className="navbar top-navbar navbar-expand-md navbar-light">
                    <div className="navbar-header">
                        <a className="navbar-brand" href="/">
                            <b>
                                <img src="assets/images/logo3.png" alt="homepage" className="dark-logo" height="50"/>
                                <img src="assets/images/logo3.png" alt="homepage" className="light-logo" height="50"/>
                            </b>
                            <span>
                            <img src="assets/images/logo-text.png" alt="homepage" className="dark-logo" height="32"/>
                            <img src="assets/images/logo-text.png" className="light-logo" alt="homepage"
                                 height="32"/></span>
                        </a>
                    </div>
                    <div className="navbar-collapse">
                        <ul className="navbar-nav mr-auto mt-md-0">
                            <li className="nav-item"><a
                                className="nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark"
                                href="javascript:void(0)"><i className="mdi mdi-menu"></i></a></li>
                            <li className="nav-item m-l-10"><a
                                className="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark"
                                href="javascript:void(0)"><i className="ti-menu"></i></a></li>
                            <li className="nav-item">
                                <div className="div-center"><h3 className="text-white text-center"></h3>
                                </div>
                            </li>
                        </ul>

                        <ul className="navbar-nav my-lg-0" style={{ gap: '8px' }}>
                            <li className="nav-item align-self-center">
                                <LanguageSwitcher className="btn btn-outline-light waves-effect" />
                            </li>
                            <li className="nav-item align-self-center">
                                <button className="btn btn-outline-light waves-effect waves-red"
                                        onClick={() => this.logout()}>
                                    {t('header.logout')}
                                </button>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header>
        )
    }
}

